import type {
  DisplayCondition,
  PersistCondition,
} from '@hotjar/feedback/domain/Surveys/Survey/Behavior';

const getDisplayConditionSummary = (
  displayCondition: DisplayCondition,
  displayDelay: number,
): string => {
  if (displayCondition === 'immediate') return 'Shown immediately';
  if (displayCondition === 'delay') return `Shown after a delay of ${displayDelay} seconds`;
  if (displayCondition === 'abandon') return 'Shown on-exit intent (desktop only)';
  if (displayCondition === 'scroll') return 'Shown on scroll';

  throw new Error('Unexpected display condition');
};

const getPersistenceSummary = (persistCondition: PersistCondition): string => {
  if (persistCondition === 'always') return 'Multiple responses';
  if (persistCondition === 'once') return 'Only shown once';
  if (persistCondition === 'response') return 'Single response';

  throw new Error('Unexpected persist condition');
};

export const BehaviorSummary = ({
  showDisplaySummary,
  displayCondition,
  displayDelay,
  persistCondition,
}: {
  showDisplaySummary: boolean;
  displayCondition: DisplayCondition;
  displayDelay: number;
  persistCondition: PersistCondition;
}): JSX.Element => {
  const displayConditionSummary = getDisplayConditionSummary(displayCondition, displayDelay);

  return (
    <span>
      {showDisplaySummary ? `${displayConditionSummary}, ` : undefined}
      {showDisplaySummary
        ? getPersistenceSummary(persistCondition).toLowerCase()
        : getPersistenceSummary(persistCondition)}
    </span>
  );
};
